import React from 'react';
import { View, StyleSheet, Dimensions, Image } from 'react-native';
import images from '../config/Images';
import Breakpoints from '../utils/Breakpoints';
import useWindowDimensions from '../utils/useWindowDimensions';
import * as GlobalVariableContext from '../config/GlobalVariableContext';

const getSize = width => {
  if (width >= Breakpoints.BigScreen) {
    return 190;
  } else if (width >= Breakpoints.Desktop) {
    return 150;
  } else if (width >= Breakpoints.Laptop) {
    return 130;
  } else {
    return 130;
  }
};

export const IconCircle = () => {
  const dimensions = useWindowDimensions();
  const SIZE = getSize(dimensions.width);
  const variables = GlobalVariableContext.useValues();
  const expenses = variables.EXPENSES;
  const data = [
    {
      value: expenses[0].value, // Finans Expense value
      color: 'black',
      source: images.finance,
    },
    {
      value: expenses[1].value, // Operating Expense value
      color: 'black',
      source: images.operating,
    },
    {
      value: expenses[2].value, // Payroll Expense value
      color: 'black',
      source: images.payrol,
    },
    {
      value: expenses[3].value, // Product Expense value
      color: 'black',
      source: images.product,
    },
  ];

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);
  const radius = SIZE / 2;

  let accumulatedAngle = -Math.PI / 2;

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.circle,
          { width: SIZE, height: SIZE, borderRadius: radius },
        ]}
      >
        {data.map((item, index) => {
          const angle = (item.value / totalValue) * 2 * Math.PI;
          const midAngle = accumulatedAngle + angle / 2;
          accumulatedAngle += angle;

          const x = radius + radius * Math.cos(midAngle) - 10;
          const y = radius + radius * Math.sin(midAngle) - 10;

          return (
            <Image
              key={index}
              style={[styles.image, { left: x, top: y }]}
              source={item.source}
            />
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    position: 'relative',
  },
  image: {
    width: 24,
    height: 24,
    position: 'absolute',
  },
});
